import { create } from "zustand";

export type sideType = "top" | "bottom" | "left" | "right";
interface ConfirmPopoverStore {
  isOpen: boolean;
  title?: string;
  description?: string;
  side?: sideType;
  anchorRect?: DOMRect;
  onConfirm: () => void;
  openPopover: (params: {
    description?: string;
    side?: sideType;
    onConfirm: () => void;
    anchorElement: HTMLElement;
  }) => void;
  closePopover: () => void;
}

export const useConfirmPopoverStore = create<ConfirmPopoverStore>((set) => ({
  isOpen: false,
  description: "",
  anchorRect: undefined,
  onConfirm: () => {},
  openPopover: ({ description, side, anchorElement, onConfirm }) =>
    set({
      isOpen: true,
      description,
      side,
      anchorRect: anchorElement.getBoundingClientRect(),
      onConfirm,
    }),
  closePopover: () =>
    set({
      isOpen: false,
      description: "",
      anchorRect: undefined,
      onConfirm: () => {},
    }),
}));
